import * as React from "react";
import { Form, Spin } from "antd";
import {
  BlockContext,
  FormBlockDef,
  RenderResult,
} from "src/components/FormWithBlocks";
import { ZGroup } from "src/types/ZGroup";
import { onError } from "src/common/onError";
import { rest } from "src/common/rest";
import { zValueThings } from "src/types/ZValueThings";
import { makeId } from "src/components/FormWithBlocks/blockTypes/makeId";
import { makeBlockId } from "src/components/FormWithBlocks/blockTypes/makeBlockId";
import { getValidStateId } from "src/common/getValidStateId";
import { apiObjUrl } from "src/common/apiUrl";
import { ZUid } from "src/types/zUid";
import { EntityGroupBlock } from "../EntityGroupBlock";
import { buildMnenoGroup } from "./buildMnemoGroup";
import { BuilderCtx } from "./BuilderCtx";

export const dependentGroup = (
  group: ZGroup,
  builderCtx: BuilderCtx,
): FormBlockDef => ({
  key: String(group.id),
  render(prevId: string, blockCtx: BlockContext): RenderResult {
    // Здесь потребовалась двойная вложенность. Потому что useWatch должен безусловно получить attributeId
    // Поэтому все условия проверяются тут. А хуки внутри DependentGroup
    const { attributeId } = group;
    if (!attributeId) return <div>Invalid attributeId</div>;
    return (
      <DependentGroup
        groupId={group.id}
        attributeId={attributeId}
        title={group.name}
        blockCtx={blockCtx}
        builderCtx={builderCtx}
        prevId={makeId(prevId, this.key)}
      />
    );
  },
});

interface PropsDependentGroup {
  attributeId: ZUid;
  title: string;
  groupId: ZUid;
  prevId: ZUid;
  blockCtx: BlockContext;
  builderCtx: BuilderCtx;
}

const DependentGroup: React.FC<PropsDependentGroup> = (props) => {
  const {
    title,
    prevId,
    attributeId,
    groupId,
    blockCtx: ctx,
    builderCtx,
  } = props;
  const currentAttrValue = Form.useWatch(String(attributeId));
  const [buzy, setBuzy] = React.useState(false);
  const [block, setBlock] = React.useState<FormBlockDef | null>(null);
  React.useEffect(() => {
    if (!currentAttrValue) {
      setBlock(null);
      return;
    }
    setBuzy(true);
    rest
      .get(
        apiObjUrl(
          `/groups/${groupId}/values/${currentAttrValue}/${getValidStateId(builderCtx.stateId)}`,
        ),
        { translate: true },
      )
      .then(({ data }) => {
        const things = zValueThings.parse(data);
        setBlock(
          buildMnenoGroup("", "", things.attributes, things.groups, builderCtx),
        );
      })
      .finally(() => {
        setBuzy(false);
      })
      .catch(onError);
  }, [currentAttrValue]);
  return (
    <Spin spinning={buzy}>
      {block && (
        <EntityGroupBlock
          title={title}
          prevId={prevId}
          ctx={ctx}
          items={block.items ?? []}
          subBlocks={block.subBlocks ?? []}
          id={makeBlockId(block.key)}
        />
      )}
    </Spin>
  );
};
